import { createStore, applyMiddleware, compose } from "redux";
import combinedReducer from "./reducers";
import thunk from "redux-thunk";

import { AssessmentEvent } from "./events/assessment.event";
import { AssessmentResponseEvent } from "./events/assessmentResponse.event";

const middleWare = [thunk];

const store =
  process.env.NODE_ENV === "development"
    ? createStore(
        combinedReducer,
        compose(
          applyMiddleware(...middleWare),
          window.__REDUX_DEVTOOLS_EXTENSION__ &&
            window.__REDUX_DEVTOOLS_EXTENSION__()
        )
      )
    : createStore(combinedReducer, compose(applyMiddleware(...middleWare)));
new AssessmentEvent(store);
// new AssessmentResponseEvent(store);

export default store;
